import dayjs from "dayjs";

export const isNotificationOlderThan24Hours = (createdAt: string): boolean => {
  const createdDate = dayjs(createdAt);
  if (!createdDate.isValid()) {
    return false;
  }

  return dayjs().diff(createdDate, "hour") > 24;
};
